import React from "react";
import { Box, Typography, Link, useMediaQuery, useTheme } from "@mui/material";
import SvgIcon from "@mui/material/SvgIcon";

const FacebookIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 12 33">
    <path fill="currentColor" d="M2.432 9.3v3.304H0v4.04h2.432v12.008h4.994V16.644h3.353s.313-1.936.465-4.054H7.446V9.827c0-.413.544-.97 1.083-.97h2.721V4.653h-3.7c-5.242 0-5.118 4.044-5.118 4.648Z" />
  </SvgIcon>
);

const TwitterIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 25 33">
    <path fill="currentColor" d="m14.863 14.814 8.742-10.162h-2.072l-7.59 8.824-6.064-8.824H.886l9.169 13.343L.886 28.652h2.072l8.017-9.318 6.403 9.318h6.992l-9.508-13.838Zm-2.838 3.299-.929-1.33L3.705 6.212h3.182l5.965 8.533.929 1.329 7.753 11.09h-3.182l-6.327-9.05Z" />
  </SvgIcon>
);

const PinterestIconCustom = (props) => (
  <SvgIcon {...props} viewBox="0 0 19 33">
    <path fill="currentColor" d="M7.76 20.324c-.564 2.468-1.116 4.845-2.32 6.72-.368.574-.739 1.298-1.369 1.608-.93-4.79 1.015-8.82 1.783-12.846-.979-2-.37-5.385 1.729-5.768 3.038-.556 2.237 3.11 1.723 4.814-.285.936-.793 1.832-.717 2.858.17 2.16 2.889 2.302 4.282 1.188 1.998-1.592 2.578-4.668 2.38-7.196-.294-3.848-4.652-5.76-8.501-4.222-1.984.792-3.784 2.614-4.046 5.292-.134 1.41.161 2.536.716 3.33.083.122.371.335.414.658.087.651-.3 1.353-.654 1.839-1.972-.567-2.988-2.335-3.15-4.575-.375-5.1 3.813-8.976 8.737-9.34 5.26-.385 9.428 2.652 9.815 7.078.288 3.29-.88 6.6-2.735 8.383-1.394 1.339-4.357 2.651-6.78 1.37-.535-.285-.775-.633-1.307-1.191Z" />
  </SvgIcon>
);

const InstagramIconCustom = (props) => (
  <SvgIcon {...props} viewBox="0 0 25 33">
    <path fill="currentColor" fillRule="evenodd" d="M7.314 4.724c1.28-.059 1.688-.072 4.947-.072 3.26 0 3.668.014 4.947.072 1.277.058 2.151.262 2.914.557.8.302 1.526.774 2.125 1.384.61.6 1.083 1.325 1.384 2.126.297.763.5 1.636.558 2.914.059 1.28.073 1.688.073 4.947 0 3.26-.014 3.667-.073 4.947-.058 1.278-.261 2.15-.557 2.914a5.888 5.888 0 0 1-1.384 2.124 5.877 5.877 0 0 1-2.126 1.384c-.763.297-1.636.5-2.913.559-1.28.058-1.688.072-4.947.072-3.26 0-3.668-.014-4.948-.072-1.277-.058-2.15-.262-2.913-.558a5.888 5.888 0 0 1-2.125-1.384 5.877 5.877 0 0 1-1.384-2.125c-.297-.764-.5-1.636-.559-2.914-.058-1.28-.072-1.687-.072-4.947s.015-3.667.072-4.947c.059-1.277.263-2.15.558-2.914.302-.8.774-1.525 1.384-2.125a5.877 5.877 0 0 1 2.126-1.384c.763-.297 1.636-.5 2.913-.558Zm9.797 2.16c-1.266-.058-1.646-.07-4.85-.07-3.204 0-3.584.012-4.85.07-1.169.053-1.804.249-2.227.413a3.714 3.714 0 0 0-1.38.897c-.42.42-.68.82-.897 1.38-.166.423-.36 1.059-.414 2.228-.057 1.266-.07 1.646-.07 4.85 0 3.204.013 3.584.07 4.85.054 1.17.25 1.804.414 2.228.192.52.499.992.897 1.38.387.398.859.704 1.38.896.423.166 1.058.36 2.228.414 1.265.057 1.645.07 4.85.07 3.204 0 3.583-.012 4.85-.07 1.169-.054 1.804-.249 2.227-.414a3.716 3.716 0 0 0 1.38-.896c.398-.388.705-.86.897-1.38.166-.424.36-1.059.413-2.229.058-1.265.07-1.645.07-4.85 0-3.203-.012-3.583-.07-4.849-.053-1.17-.248-1.805-.413-2.228a3.707 3.707 0 0 0-.897-1.38c-.42-.419-.82-.68-1.38-.897-.423-.165-1.058-.36-2.228-.413ZM10.73 20.35a4.003 4.003 0 1 0 3.064-7.396 4.003 4.003 0 0 0-3.064 7.396Zm-2.83-8.06a6.168 6.168 0 1 1 8.723 8.723A6.168 6.168 0 0 1 7.9 12.29Zm11.897-.888a1.458 1.458 0 1 0-2.061-2.062 1.458 1.458 0 0 0 2.061 2.062Z" clipRule="evenodd" />
  </SvgIcon>
);

const TikTokIconCustom = (props) => (
  <SvgIcon {...props} viewBox="0 0 22 33">
    <path fill="currentColor" d="M21.432 14.362a6.39 6.39 0 0 1-.59.03 6.407 6.407 0 0 1-5.36-2.897v9.865a7.292 7.292 0 1 1-7.292-7.292c.152 0 .3.014.45.023v3.594c-.15-.018-.296-.045-.45-.045a3.721 3.721 0 1 0 0 7.442c2.056 0 3.87-1.62 3.87-3.675l.037-16.755h3.437a6.403 6.403 0 0 0 5.902 5.716v3.994" />
  </SvgIcon>
);

const YouTubeIconCustom = (props) => (
  <SvgIcon {...props} viewBox="0 0 15 15">
    <path fill="currentColor" d="M14.85 4.5s-.146-1.034-.597-1.488c-.571-.598-1.21-.6-1.503-.636-2.098-.152-5.247-.152-5.247-.152h-.006s-3.15 0-5.247.152c-.293.035-.932.038-1.503.636C.296 3.466.152 4.5.152 4.5S0 5.716 0 6.929v1.136c0 1.213.15 2.43.15 2.43s.146 1.033.594 1.487c.571.598 1.321.578 1.655.642 1.202.114 5.101.15 5.101.15s3.152-.006 5.25-.156c.293-.035.932-.038 1.503-.636.451-.454.598-1.488.598-1.488S15 9.281 15 8.065V6.93c0-1.213-.15-2.429-.15-2.429Zm-8.9 4.945V5.23l4.052 2.116-4.052 2.1Z" />
  </SvgIcon>
);

const VisaIcon = () => (
  <svg width="32" height="24" viewBox="0 0 32 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15.8443 6.99504L13.7065 16.99H11.1205L13.2586 6.99504H15.8443ZM26.723 13.4489L28.0839 9.6956L28.8672 13.4489H26.723ZM29.609 16.99H32L29.9111 6.99504H27.7056C27.2086 6.99504 26.7895 7.28324 26.6041 7.72767L22.7242 16.99H25.4398L25.9789 15.4973H29.2959L29.609 16.99ZM22.8588 13.727C22.8701 11.0891 19.2123 10.943 19.2368 9.76439C19.2447 9.40627 19.5864 9.02478 20.3332 8.92722C20.7034 8.87956 21.7252 8.8409 22.8833 9.37458L23.3363 7.25424C22.7143 7.02921 21.9138 6.8125 20.9177 6.8125C18.3614 6.8125 16.5632 8.17031 16.5489 10.1162C16.5324 11.5552 17.8334 12.3575 18.8115 12.8368C19.82 13.3266 20.1578 13.6407 20.1529 14.0784C20.1459 14.7489 19.3488 15.0459 18.6065 15.0571C17.3058 15.0774 16.5518 14.7056 15.9509 14.4254L15.4815 16.6166C16.0867 16.8936 17.2017 17.1345 18.3563 17.1469C21.0739 17.1469 22.8508 15.8051 22.8588 13.727ZM12.1495 6.99504L7.95982 16.99H5.22689L3.165 9.01332C3.04001 8.5228 2.93098 8.34251 2.55084 8.13524C1.92903 7.79759 0.902583 7.48174 0 7.28526L0.0611471 6.99504H4.46099C5.02142 6.99504 5.52565 7.36799 5.65401 8.01362L6.74318 13.7978L9.43295 6.99504H12.1495Z" fill="white" />
  </svg>
);

const MastercardIcon = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill="white" fillRule="evenodd" d="M16 23.789a9.89 9.89 0 1 1 0-15.55 9.889 9.889 0 1 1 0 15.55Zm-3.777-7.775A9.871 9.871 0 0 1 16 8.24a9.89 9.89 0 0 1 0 15.55 9.87 9.87 0 0 1-3.777-7.775Zm5.395 7.67a8.888 8.888 0 1 0 0-15.34 10.892 10.892 0 0 1 0 15.34Z" clipRule="evenodd" />
    <path fill="white" d="M31.057 21.823v.319h-.07v-.319h-.129v-.065h.327v.065h-.128ZM31.691 21.758v.384h-.07v-.29l-.108.25h-.074l-.108-.25v.29h-.07v-.384h.1l.115.264.115-.264h.1Z" />
  </svg>
);

const ApplePayIcon = () => (
  <svg width="40" height="32" viewBox="0 0 40 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill="white" d="M33.21 24.928c1.844 0 2.712-.703 3.47-2.836L40 12.78h-1.922l-2.227 7.206h-.04l-2.226-7.196h-1.977l3.204 8.864-.172.54a1.503 1.503 0 0 1-1.594 1.265c-.149 0-.437-.016-.554-.031v1.464c.238.032.479.048.718.047v-.01Zm-6.406-4.664c-1.008 0-1.648-.488-1.648-1.226 0-.765.617-1.211 1.797-1.282l2.101-.132v.688a2.056 2.056 0 0 1-2.137 1.97c-.038-.002-.076-.006-.113-.009v-.009Zm-.508 1.445a3.128 3.128 0 0 0 2.79-1.555h.039v1.464h1.75v-6.062c0-1.758-1.406-2.891-3.571-2.891-2.008 0-3.493 1.148-3.547 2.726h1.703a1.66 1.66 0 0 1 1.79-1.242c1.156 0 1.804.539 1.804 1.531v.672l-2.358.14c-2.196.133-3.383 1.032-3.383 2.595-.002 1.585 1.224 2.631 2.983 2.631v-.009ZM16.155 11.03h2.18c1.64 0 2.578.875 2.578 2.415s-.938 2.421-2.586 2.421h-2.172V11.03Zm-1.891-1.594v12.18h1.89v-4.151h2.619a3.865 3.865 0 0 0 4.07-4.016 3.823 3.823 0 0 0-4.008-4l-4.571-.013Zm-6.276 2.273c-1.086-.062-2.016.618-2.531.618-.516 0-1.313-.586-2.172-.57a3.209 3.209 0 0 0-2.727 1.657c-1.172 2.016-.305 5 .828 6.64.554.814 1.22 1.704 2.094 1.673.828-.031 1.156-.54 2.157-.54 1 0 1.297.54 2.172.523.906-.015 1.476-.813 2.033-1.626a7.12 7.12 0 0 0 .906-1.87 2.944 2.944 0 0 1-1.766-2.684 3.01 3.01 0 0 1 1.43-2.515A3.096 3.096 0 0 0 7.99 11.7l-.002.007Zm-.678-1.076c-.476.6-1.203.944-1.969.93a2.787 2.787 0 0 1 .704-2.039 2.937 2.937 0 0 1 1.952-1.007 2.963 2.963 0 0 1-.688 2.114" />
  </svg>
);

const PayPalIcon = () => (
  <svg width="18" height="32" viewBox="0 0 18 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill="white" fillRule="evenodd" d="M14.953 11.459c.214.075.414.161.6.26.249-1.584-.001-2.662-.858-3.639-.944-1.075-2.648-1.535-4.828-1.535h-6.33a.905.905 0 0 0-.894.764L.007 24.021a.544.544 0 0 0 .536.629h3.908l-.269 1.71a.475.475 0 0 0 .469.549h3.294c.39 0 .721-.284.782-.668l.033-.168.62-3.935.04-.216a.792.792 0 0 1 .783-.67h.492c3.191 0 5.69-1.295 6.42-5.044.305-1.567.147-2.874-.66-3.794a3.15 3.15 0 0 0-.902-.695c-.01.07-.023.14-.035.213l-.001.004m-.029.154a10.722 10.722 0 0 0 0 0Zm-.535-.631c.214.075.414.16.6.26ZM4.451 24.65l.109-.69-.109.69Z" clipRule="evenodd" />
  </svg>
);

const GooglePayIcon = () => (
  <svg width="40" height="32" viewBox="0 0 40 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill="white" d="M18.916 16.548v4.623H17.44V9.753h3.918a3.564 3.564 0 0 1 2.537.988 3.179 3.179 0 0 1 1.06 2.41 3.145 3.145 0 0 1-1.06 2.424c-.685.648-1.531.972-2.537.972h-2.44Zm0-5.39v3.987h2.478a1.964 1.964 0 0 0 1.461-.59 1.946 1.946 0 0 0 .594-1.396 1.934 1.934 0 0 0-.594-1.396 1.927 1.927 0 0 0-1.461-.605h-2.477ZM28.358 13.104c1.092 0 1.954.29 2.585.869.632.58.948 1.374.947 2.383v4.815h-1.413v-1.084h-.064c-.611.893-1.425 1.34-2.44 1.34-.867 0-1.592-.256-2.175-.766a2.445 2.445 0 0 1-.876-1.913c0-.809.308-1.452.923-1.93.616-.477 1.437-.716 2.465-.717.877 0 1.599.16 2.166.478v-.335a1.66 1.66 0 0 0-.61-1.298 2.1 2.1 0 0 0-1.425-.535c-.825 0-1.478.346-1.96 1.037l-1.3-.814c.716-1.02 1.775-1.53 3.177-1.53Zm-1.91 5.676a1.165 1.165 0 0 0 .489.956c.327.255.732.39 1.148.383a2.363 2.363 0 0 0 1.661-.685c.49-.458.734-.994.734-1.61-.46-.365-1.103-.547-1.927-.547-.6 0-1.1.144-1.5.431-.405.292-.606.646-.606 1.072ZM40 13.357 35.07 24.614h-1.525l1.83-3.939-3.243-7.318h1.605l2.344 5.613h.032l2.28-5.613h1.609ZM12.949 15.55c0-.446-.038-.893-.114-1.333h-6.23v2.526h3.568a3.024 3.024 0 0 1-1.319 1.994v1.64h2.13c1.246-1.142 1.965-2.83 1.965-4.826Z" /><path fill="white" d="M6.605 21.96c1.783 0 3.284-.58 4.378-1.583l-2.13-1.64c-.592.4-1.355.627-2.248.627-1.723 0-3.185-1.153-3.708-2.708H.703v1.69c.55 1.087 1.393 2 2.435 2.638a6.64 6.64 0 0 0 3.467.977Z" /><path fill="white" d="M2.897 16.656a3.905 3.905 0 0 1 0-2.51v-1.69H.703a6.522 6.522 0 0 0 0 5.89l2.194-1.69Z" /><path fill="white" d="M6.605 11.437a3.6 3.6 0 0 1 2.534.984l1.885-1.872A6.371 6.371 0 0 0 6.605 8.84a6.64 6.64 0 0 0-3.467.977 6.577 6.577 0 0 0-2.435 2.638l2.194 1.69c.523-1.555 1.985-2.708 3.708-2.708Z" />
  </svg>
);

const AmericanTouristerIcon = () => (
  <svg width="50" height="20" viewBox="0 0 50 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill="white" d="m18.57 18.013 1.12 1.278h4.592v-1.917h.44a4.852 4.852 0 0 0 1.956-.28v2.197h3.794v-2.116h.2c.24 0 .24 0 .24.24v1.876h11.461a3.502 3.502 0 0 0 1.916-.52v.52h3.635a5.664 5.664 0 0 0 2.076-.36v-1.557h-.04c-.36.52-.998.76-1.917.76h-2.715v-1.28h2.715a.724.724 0 0 0 .56-.16.53.53 0 0 0 .16-.398.611.611 0 0 0-.16-.4.767.767 0 0 0-.48-.12c-1.318-.04-2.955.04-2.955-1.836 0-.84.56-1.757 1.997-1.757h2.795v-1.158h-2.596a2.975 2.975 0 0 0-1.757.479v-.48h-3.833a2.795 2.795 0 0 0-1.678.48v-.48h-6.869v.48a3.634 3.634 0 0 0-1.877-.48h-4.552v.48c-.44-.4-1.398-.48-1.997-.48H19.77l-1.158 1.318-1.078-1.238H9.945v8.187h7.428l1.197-1.278ZM38.978 13.5h-3.275v1.078h3.195v1.198h-3.195v1.158h3.275v1.238h-4.673v-5.91h4.673V13.5Zm2.636-1.318h2.795v1.238h-2.556c-.28 0-.439 0-.559.12-.12.12-.2.24-.2.439a.43.43 0 0 0 .32.44c.182.05.37.078.56.08h.758c.8.079 1.278.199 1.597.518a1.598 1.598 0 0 1 .44 1.238c0 1.278-.799 1.837-2.197 1.837h-2.755v-1.238h2.715a.724.724 0 0 0 .56-.16.53.53 0 0 0 .16-.4.611.611 0 0 0-.16-.4.823.823 0 0 0-.52-.118c-1.318-.04-2.955.04-2.955-1.837 0-.84.52-1.757 1.997-1.757Zm-8.107 1.677a1.557 1.557 0 0 1-.959 1.518c.266.095.5.26.68.479.2.322.284.702.24 1.078v1.158h-1.399v-.72c0-.358.04-.877-.24-1.157a1.406 1.406 0 0 0-1.038-.28h-1.517v2.157h-1.398v-5.83h3.235a3.43 3.43 0 0 1 1.677.28 1.406 1.406 0 0 1 .72 1.317Zm-22.284 4.233v-5.83h5.63l1.718 1.917 1.797-1.917h4.473c1.118 0 2.356.32 2.356 1.917S26 16.136 24.761 16.136h-1.757v1.957h-2.716l-1.717-1.957-1.797 1.957h-5.55Z" /><path fill="white" d="M46.645 14.06a.43.43 0 0 0 .32.44c.168.048.343.075.518.08h.76c.758.04 1.277.16 1.597.48.05.044.09.098.12.158V13.5h-2.556c-.24 0-.44 0-.56.12-.12.12-.2.24-.2.44Zm-17.37-.6v1.318h1.717c.233.022.467-.019.679-.12a.535.535 0 0 0 .28-.558.508.508 0 0 0-.28-.52 1.222 1.222 0 0 0-.68-.12h-1.716Zm-3.596.76c0-.52-.32-.72-.838-.72h-1.837v1.478h1.837c.519 0 .878-.279.838-.758Zm-13.06-.76v1.08h3.075v1.197H12.62v1.158h3.435l1.597-1.717-1.517-1.717h-3.516Zm8.985-.558-2.156 2.316 2.156 2.396v-4.712Zm4.072-9.425a1.222 1.222 0 0 0-.68-.12H23.28v1.318h1.717c.233.023.468-.019.679-.12a.595.595 0 0 0 .28-.559.508.508 0 0 0-.28-.52v.001ZM2.596 5.473h1.918l-.96-2.356-.958 2.356ZM36.9 3.117l-.96 2.356h1.918L36.9 3.117Z" /><path fill="white" d="M27.196.994v.48a2.316 2.316 0 0 0-1.597-.48H11.98l-.919 2.117-.918-2.117H5.83v.959L5.35.994H1.677L0 4.868v4.313h2.396l.56-1.318h1.197l.52 1.318h4.752v-.998l.44.998H12.3l.4-.998v.998h11.74V7.024h.24c.16 0 .2.04.2.28v1.877h6.07v-.52a4.488 4.488 0 0 0 2.236.52h2.556l.56-1.318h1.197l.52 1.318h4.912V7.943l.759 1.238h3.953V.994H43.73v.959l-.559-.959h-3.993v.959l-.52-.959h-5.39a4.792 4.792 0 0 0-2.357.48v-.48h-3.715Zm1.118 1.158h1.438v5.87h-1.438v-5.87Zm-12.1 0h4.672V3.39h-3.274v1.04h3.195v1.198h-3.195v1.158h3.274v1.238h-4.672V2.152Zm-4.513 5.87h-1.238L8.426 3.43v4.593H5.591l-.56-1.318H2.118l-.56 1.318H.04l2.516-5.87h2.077l2.396 5.55v-5.55h2.276l1.837 3.993 1.677-3.994h2.317v5.87h-1.398V3.43L11.7 8.023h.001Zm13.06-2.196h-1.518v2.117h-1.398v-5.79h3.235a3.694 3.694 0 0 1 1.717.279 1.342 1.342 0 0 1 .719 1.278 1.645 1.645 0 0 1-.999 1.557c.266.096.5.261.68.48.2.321.284.702.239 1.078v1.158h-1.398v-.759c0-.36.04-.879-.24-1.158-.2-.2-.518-.24-1.037-.24Zm6.429-2.955c.439-.48 1.158-.679 2.116-.679h1.358V3.43h-1.318a1.318 1.318 0 0 0-1.078.36 1.917 1.917 0 0 0-.4 1.317c-.047.5.096 1 .4 1.398a1.275 1.275 0 0 0 .958.32h.64l1.996-4.633h2.117l2.356 5.551v-5.59h2.156l2.477 4.073V2.152h1.437v5.87h-2.037L41.694 3.63v4.393h-2.876l-.559-1.318h-2.876l-.52 1.318h-1.637c-.678 0-1.557-.16-2.036-.64a3.014 3.014 0 0 1-.76-2.236c0-.878.159-1.677.759-2.276Z" />
  </svg>
);

const ShopPayIcon = () => (
  <svg width="37" height="16" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 37 16">
    <path fill="currentColor" d="M21.637 4.551c0 2.29-1.537 3.924-3.684 3.924H15.93a.163.163 0 0 0-.12.053.18.18 0 0 0-.05.125v3.01a.182.182 0 0 1-.049.125.167.167 0 0 1-.12.053h-1.415a.166.166 0 0 1-.095-.03.177.177 0 0 1-.076-.147V.804a.184.184 0 0 1 .05-.126.17.17 0 0 1 .12-.052h3.787c2.139-.002 3.675 1.632 3.675 3.925Zm-1.765 0c0-1.316-.86-2.278-2.025-2.278H15.93a.165.165 0 0 0-.12.052.18.18 0 0 0-.05.126v4.19c0 .047.019.092.05.126a.166.166 0 0 0 .12.051h1.917c1.165.01 2.025-.954 2.025-2.267Zm2.185 5.206a2.19 2.19 0 0 1 .202-1.016c.148-.316.368-.589.642-.793.552-.434 1.416-.658 2.683-.705l1.35-.05v-.416c0-.834-.535-1.186-1.394-1.186-.86 0-1.404.318-1.53.838a.172.172 0 0 1-.06.091.16.16 0 0 1-.102.033h-1.334a.162.162 0 0 1-.13-.06.177.177 0 0 1-.04-.142c.198-1.233 1.18-2.17 3.257-2.17 2.209 0 3.006 1.074 3.006 3.126v4.356a.184.184 0 0 1-.051.126.168.168 0 0 1-.122.052H27.09a.168.168 0 0 1-.157-.11.185.185 0 0 1-.012-.067v-.326a.137.137 0 0 0-.021-.076.129.129 0 0 0-.059-.05.122.122 0 0 0-.14.032c-.404.458-1.055.79-2.098.79-1.534 0-2.546-.835-2.546-2.277Zm4.877-.944v-.338l-1.748.097c-.921.049-1.457.449-1.457 1.122 0 .608.492.945 1.35.945 1.166 0 1.855-.657 1.855-1.826Zm3.023 6.319V13.87a.187.187 0 0 1 .063-.138.17.17 0 0 1 .143-.038c.205.04.415.061.625.062.36.019.717-.09 1.012-.308.295-.219.51-.534.614-.895l.087-.291a.195.195 0 0 0 0-.12l-2.8-7.515a.189.189 0 0 1 .017-.167.175.175 0 0 1 .062-.058.167.167 0 0 1 .08-.021h1.358c.034 0 .068.012.097.032.028.021.05.05.062.084l1.902 5.3a.18.18 0 0 0 .064.087.167.167 0 0 0 .2 0 .18.18 0 0 0 .062-.087l1.652-5.285a.18.18 0 0 1 .063-.09.168.168 0 0 1 .102-.034h1.405a.17.17 0 0 1 .142.079.187.187 0 0 1 .02.168l-2.996 8.345c-.69 1.94-1.872 2.436-3.174 2.436a2.426 2.426 0 0 1-.733-.092.174.174 0 0 1-.098-.072.188.188 0 0 1-.031-.12ZM4.908 0a6.813 6.813 0 0 0-4.81 1.96.329.329 0 0 0-.038.426l.808 1.152a.313.313 0 0 0 .228.135.297.297 0 0 0 .244-.096 4.98 4.98 0 0 1 1.64-1.14 4.805 4.805 0 0 1 1.935-.386c2.769 0 4.215 2.177 4.215 4.326 0 2.337-1.52 3.981-3.703 4.014-1.687 0-2.959-1.168-2.959-2.712.002-.39.087-.774.248-1.126a2.62 2.62 0 0 1 .685-.907.328.328 0 0 0 .042-.444l-.849-1.12a.313.313 0 0 0-.21-.12.298.298 0 0 0-.23.073A4.657 4.657 0 0 0 .921 5.66c-.289.63-.44 1.321-.44 2.02 0 2.657 2.162 4.741 4.93 4.758h.037c3.287-.044 5.664-2.588 5.664-6.064C11.113 3.286 8.936 0 4.91 0Z"></path>
  </svg>
);

const MaestroIcon = () => (
  <svg width="28" height="17" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 28 17">
    <path fill="currentColor" d="M12.924 11.765c.049.045.103.087.156.132a6.445 6.445 0 0 1-3.595 1.083A6.488 6.488 0 0 1 3 6.49 6.49 6.49 0 0 1 9.49 0c1.276 0 2.528.375 3.594 1.083a6.989 6.989 0 0 0-.156 10.682h-.005ZM17.51 0a6.498 6.498 0 0 0-3.595 1.083 6.989 6.989 0 0 1 .156 10.682c-.05.045-.103.087-.156.132a6.445 6.445 0 0 0 3.595 1.083A6.49 6.49 0 0 0 24 6.49 6.487 6.487 0 0 0 17.51 0ZM13.5 1.392c-.082.066-.165.132-.247.202A6.463 6.463 0 0 0 11.02 6.49a6.49 6.49 0 0 0 2.232 4.896c.078.07.165.136.247.202.082-.066.165-.132.247-.202A6.463 6.463 0 0 0 15.98 6.49 6.49 6.49 0 0 0 13.5 1.392ZM18.263 14.585c.09 0 .181.017.268.046l-.116.354a.566.566 0 0 0-.234-.041c-.243 0-.367.16-.367.444v.968h-.375v-1.725h.371v.21a.51.51 0 0 1 .453-.252v-.004Zm-1.384.387h-.613v.779c0 .173.062.288.247.288a.668.668 0 0 0 .33-.099l.106.321a.861.861 0 0 1-.469.132c-.445 0-.597-.239-.597-.638v-.787h-.35v-.341h.35v-.524h.379v.524h.613v.341l.004.005Zm-4.797.367a.446.446 0 0 1 .457-.42.428.428 0 0 1 .437.42h-.894Zm1.285.152a.826.826 0 0 0-.741-.902h-.074a.906.906 0 0 0 .029 1.812c.255.009.506-.078.708-.243l-.185-.28a.824.824 0 0 1-.503.182.477.477 0 0 1-.515-.42h1.281c0-.046.008-.095.008-.145l-.008-.004Zm1.647-.42a1.114 1.114 0 0 0-.535-.148c-.206 0-.33.074-.33.202 0 .115.128.148.293.169l.177.024c.374.054.601.215.601.515 0 .33-.288.564-.787.564a1.232 1.232 0 0 1-.745-.222l.177-.293a.92.92 0 0 0 .573.182c.255 0 .39-.074.39-.21 0-.1-.098-.153-.304-.181l-.177-.025c-.387-.054-.597-.227-.597-.507 0-.341.28-.552.716-.552.248-.008.49.054.705.182l-.161.3h.004Zm4.624-.127a.537.537 0 0 0-.502.333.647.647 0 0 0 0 .45.548.548 0 0 0 .115.176c.05.05.107.087.173.115a.59.59 0 0 0 .428 0 .522.522 0 0 0 .289-.288.648.648 0 0 0 0-.449.522.522 0 0 0-.289-.288.55.55 0 0 0-.214-.041v-.008Zm0-.355a.956.956 0 0 1 .667.26.912.912 0 0 1 .194.288.96.96 0 0 1 0 .725.867.867 0 0 1-.49.478c-.239.09-.503.09-.741 0a.934.934 0 0 1-.297-.19.91.91 0 0 1-.193-.288.96.96 0 0 1 0-.725.87.87 0 0 1 .49-.478c.119-.045.243-.07.37-.07Zm-9.742.906a.521.521 0 1 1 0 .042v-.042Zm1.396 0v-.86h-.375v.21a.643.643 0 0 0-.543-.251.903.903 0 0 0-.906.906c0 .502.403.905.906.905a.66.66 0 0 0 .543-.25v.21h.375v-.87Zm-2.113.861v-1.083a.641.641 0 0 0-.597-.684H8.5a.67.67 0 0 0-.605.305.628.628 0 0 0-.569-.305.576.576 0 0 0-.506.256v-.214h-.375v1.725h.38v-.955a.401.401 0 0 1 .345-.453c.025 0 .054-.004.078 0 .247 0 .375.16.375.453v.96h.379v-.956a.408.408 0 0 1 .35-.457h.07c.255 0 .379.16.379.453v.96h.378v-.005Z"></path>
  </svg>
);

const Footer = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // Mobile: < 600px
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md")); // Tablet: 600px - 900px
  const isLaptop = useMediaQuery(theme.breakpoints.between("md", "lg")); // Laptop: 900px - 1200px

  // Responsive styles for the "DAINASOUL" text
  const getResponsiveStyles = () => {
    if (isMobile) {
      return {
        fontSize: "40px",
        letterSpacing: "6px",
        lineHeight: "1.2",
      };
    } else if (isTablet) {
      return {
        fontSize: "80px",
        letterSpacing: "12px",
        lineHeight: "1.2",
      };
    } else if (isLaptop) {
      return {
        fontSize: "120px",
        letterSpacing: "18px",
        lineHeight: "1.2",
      };
    } else {
      return {
        fontSize: "160px",
        letterSpacing: "24px",
        lineHeight: "1.2",
      };
    }
  };

  // Responsive padding for the footer
  const getFooterPadding = () => {
    if (isMobile) {
      return "20px";
    } else if (isTablet) {
      return "30px";
    } else {
      return "40px";
    }
  };

  // Footer link styles
  const linkStyles = {
    color: "#fff",
    textDecoration: "none",
    margin: isMobile ? "0 8px" : "0 12px",
    fontSize: isMobile ? "14px" : "16px",
    "&:hover": {
      textDecoration: "underline",
    },
  };

  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: "#000",
        color: "#fff",
        padding: getFooterPadding(),
        textAlign: "center",
      }}
    >
      {/* Footer Links */}
      <Box
        sx={{
          mb: 3,
          display: "flex",
          flexDirection: isMobile ? "column" : "row",
          flexWrap: "wrap",
          justifyContent: "center",
          alignItems: "center",
          gap: isMobile ? 1.5 : 2,
        }}
      >
        <Link href="/contact" sx={linkStyles}>
          Contact & Customer Service
        </Link>
        <Link href="/terms" sx={linkStyles}>
          Terms & Conditions
        </Link>
        <Link href="/privacy" sx={linkStyles}>
          Privacy Policy
        </Link>
        <Link href="/return-policy" sx={linkStyles}>
          Return Policy
        </Link>
        <Link href="/sustainability" sx={linkStyles}>
          Sustainability
        </Link>
        <Link href="/track-order" sx={linkStyles}>
          Track Order
        </Link>
        <Link href="/return-order" sx={linkStyles}>
          Return Order
        </Link>
        <Link href="/about" sx={linkStyles}>
          About
        </Link>
        <Link href="/faq" sx={linkStyles}>
          FAQ
        </Link>
      </Box>

      {/* Social Media Icons */}
      <Box sx={{ display: "flex", justifyContent: "center", gap: (isMobile || isTablet) ? 2 : 3.5, mb: (isMobile || isTablet) ? 1.5 : 3 }}>
        <Link
          href="https://www.instagram.com/dainasoulofficial"
          target="_blank"
          rel="noopener"
          sx={{ color: "#fff" }}
        >
          <InstagramIconCustom sx={{ fontSize: "30px" }} />
        </Link>
        <Link
          href="https://www.facebook.com/dainasoul"
          target="_blank"
          rel="noopener"
          sx={{ color: "#fff" }}
        >
          <FacebookIcon sx={{ fontSize: "30px" }} />
        </Link>
        <Link
          href="https://www.twitter.com/dainasoulwear"
          target="_blank"
          rel="noopener"
          sx={{ color: "#fff" }}
        >
          <TwitterIcon sx={{ fontSize: "30px" }} />
        </Link>
        <Link
          href="https://www.pinterest.com/dainasoul"
          target="_blank"
          rel="noopener"
          sx={{ color: "#fff" }}
        >
          <PinterestIconCustom sx={{ fontSize: "30px" }} />
        </Link>
        <Link
          href="https://www.youtube.com/@dainasoulofficial"
          target="_blank"
          rel="noopener"
          sx={{ color: "#fff" }}
        >
          <YouTubeIconCustom sx={{ fontSize: "34px" }} />
        </Link>
        <Link
          href="https://www.tiktok.com/@dainasoul"
          target="_blank"
          rel="noopener"
          sx={{ color: "#fff" }}
        >
          <TikTokIconCustom sx={{ fontSize: "30px" }} />
        </Link>
      </Box>

      {/* DAINASOUL Heading */}
      <Typography
        variant="h1"
        sx={{
          flexGrow: 5,
          color: "#fff",
          fontFamily: '"Playfair Display", serif',
          textTransform: "uppercase",
          mb: 2,
          ...getResponsiveStyles(),
        }}
      >
        DAINASOUL
      </Typography>

      {/* Footer Bottom Section */}
      <Box
        sx={{
          display: "flex",
          flexDirection: (isMobile || isTablet) ? "column" : "row",
          justifyContent: (isMobile || isTablet) ? "center" : "space-between",
          alignItems: "center",
          gap: 2,
          pt: 4,
          position: "relative",
          "&::before": {
            content: (isMobile || isTablet) ? 'none' : '""',
            position: "absolute",
            top: 0,
            left: "1%",
            right: "1%",
            height: "1px",
            backgroundColor: "rgba(255,255,255,0.2)",
          },
          px: (isMobile || isTablet) ? 0 : 2
        }}
      >
        {/* Payment Icons - Order 1 on mobile/tablet */}
        <Box
          sx={{
            display: "flex",
            gap: (isMobile || isTablet) ? 2 : 3.5,
            flexWrap: "wrap",
            alignItems: "center",
            justifyContent: (isMobile || isTablet) ? "center" : "flex-end",
            order: (isMobile || isTablet) ? 1 : 2
          }}
        >
          <VisaIcon />
          <MastercardIcon />
          <ApplePayIcon />
          <GooglePayIcon />
          <PayPalIcon />
          <AmericanTouristerIcon />
          <ShopPayIcon />
          <MaestroIcon />
        </Box>

        {/* Copyright - Order 2 on mobile/tablet */}
        <Typography
          variant="body1"
          sx={{
            fontSize: "12px",
            color: 'rgba(255,255,255,0.6)',
            order: (isMobile || isTablet) ? 2 : 1,
            mt: (isMobile || isTablet) ? 2 : 0
          }}
        >
          © {new Date().getFullYear()} Dainasoul. All rights reserved.
        </Typography>
      </Box>
    </Box>
  );
};

export default Footer;
